import React from 'react';
export const Footer: React.FC = () => {
  return <footer className="bg-navy text-gray-400 py-12 px-4 sm:px-6 lg:px-8 text-sm text-center" data-id="element-62">
      <div className="max-w-4xl mx-auto space-y-6" data-id="element-63">
        <p data-id="element-64">
          © 2026 Abordaje del Insomnio en Ansiedad y Depresión. Todos los
          derechos reservados.
        </p>
        <p className="max-w-3xl mx-auto leading-relaxed" data-id="element-65">
          Este material es una herramienta educativa y profesional para
          psicólogos y terapeutas. No reemplaza formación específica.
        </p>
        <p className="text-xs opacity-70" data-id="element-66">
          Este sitio no es parte del sitio web de Facebook o Meta Inc. Además,
          este sitio NO está respaldado por Facebook de ninguna manera.
        </p>
      </div>
    </footer>;
};